// assets
import {
  IconDashboard,
  IconClipboardList,
  IconPhoto,
  IconUsers,
  IconAddressBook,
  IconCalculator,
  IconAlertTriangle,
  IconBriefcase,
  IconTool,
  IconBuildingStore,
  IconNews,
  IconNotebook,
  IconMessages,
  IconFolder,
  IconSpeakerphone,
  IconFlag,
  IconCreditCard,
  IconRobot,
  IconLanguage,
  IconSettings,
  IconFileText,
  IconReportAnalytics
} from '@tabler/icons';

// constant
const icons = {
  IconDashboard,
  IconClipboardList,
  IconPhoto,
  IconUsers,
  IconAddressBook,
  IconCalculator,
  IconAlertTriangle,
  IconBriefcase,
  IconTool,
  IconBuildingStore,
  IconNews,
  IconNotebook,
  IconMessages,
  IconFolder,
  IconSpeakerphone,
  IconFlag,
  IconCreditCard,
  IconRobot,
  IconLanguage,
  IconSettings,
  IconFileText,
  IconReportAnalytics
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  title: '메뉴',
  type: 'group',
  children: [
    {
      id: 'dashboard-home',
      title: '대시보드',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      // 사용자 이용 통계 (usageDailyStats 요약문서만 읽음) — 2026-10-15 메뉴 공개
      id: 'usage-stats',
      title: '이용 통계',
      type: 'item',
      url: '/usage-stats',
      icon: icons.IconReportAnalytics,
      breadcrumbs: false
    },
    {
      id: 'banners',
      title: '배너 관리',
      type: 'item',
      url: '/banners',
      icon: icons.IconPhoto,
      breadcrumbs: false
    },
    {
      id: 'users',
      title: '사용자 관리',
      type: 'item',
      url: '/users',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    // {
    //   id: 'recommenders',
    //   title: '추천인 관리',
    //   type: 'item',
    //   url: '/recommenders',
    //   icon: icons.IconClipboardList,
    //   breadcrumbs: false
    // },
    {
      id: 'profiles',
      title: '프로필 관리',
      type: 'item',
      url: '/profiles',
      icon: icons.IconAddressBook,
      breadcrumbs: false
    },
    {
      id: 'calculators',
      title: '전기계산기',
      type: 'item',
      url: '/calculators',
      icon: icons.IconCalculator,
      breadcrumbs: false
    },
    {
      id: 'calcErrorReports',
      title: '전기계산기 오류보고',
      type: 'item',
      url: '/calc-error-reports',
      icon: icons.IconAlertTriangle,
      breadcrumbs: false
    },
    {
      id: 'findTechnicians',
      title: '구인 구직',
      type: 'item',
      url: '/find-technicians',
      icon: icons.IconBriefcase,
      breadcrumbs: false
    },
    {
      id: 'requestWorks',
      title: '시공문의',
      type: 'item',
      url: '/request-works',
      icon: icons.IconTool,
      breadcrumbs: false
    },
    {
      id: 'markets',
      title: '전기장터',
      type: 'item',
      url: '/markets',
      icon: icons.IconBuildingStore,
      breadcrumbs: false
    },
    {
      id: 'companyNewss',
      title: '업체소식',
      type: 'item',
      url: '/company-newss',
      icon: icons.IconNews,
      breadcrumbs: false
    },
    {
      id: 'constructionDiarys',
      title: '시공 다이어리',
      type: 'item',
      url: '/construction-diarys',
      icon: icons.IconNotebook,
      breadcrumbs: false
    },
    {
      id: 'qnas',
      title: '커뮤니티',
      type: 'item',
      url: '/qnas',
      icon: icons.IconMessages,
      breadcrumbs: false
    },
    {
      id: 'archives',
      title: '자료실',
      type: 'item',
      url: '/archives',
      icon: icons.IconFolder,
      breadcrumbs: false
    },
    {
      id: 'notices',
      title: '공지사항 관리',
      type: 'item',
      url: '/notices',
      icon: icons.IconSpeakerphone,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: '신고 관리',
      type: 'item',
      url: '/reports',
      icon: icons.IconFlag,
      breadcrumbs: false
    },
    // {
    //   id: 'jobPostings',
    //   title: '정규직(비상근) 구인/구직 관리',
    //   type: 'item',
    //   url: '/job-postings',
    //   icon: icons.IconClipboardList,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'interviewOffers',
    //   title: '면접제의 관리',
    //   type: 'item',
    //   url: '/interview-offers-isoffer',
    //   icon: icons.IconClipboardList,
    //   breadcrumbs: false
    // },
    {
      id: 'payments',
      title: '결제 관리',
      type: 'item',
      url: '/payments',
      icon: icons.IconCreditCard,
      breadcrumbs: false
    },
    
    {
      id: 'geminiConfigs',
      title: 'AI 챗봇',
      type: 'item',
      url: '/gemini-config-detail',
      icon: icons.IconRobot,
      breadcrumbs: false
    },
    {
      id: 'translations',
      title: '번역 관리',
      type: 'item',
      url: '/translations',
      icon: icons.IconLanguage,
      breadcrumbs: false
    },
    {
      id: 'generalConfigs',
      title: '기타 설정',
      type: 'item',
      url: '/general-config-detail',
      icon: icons.IconSettings,
      breadcrumbs: false
    },
    {
      id: 'policys',
      title: '약관 / 개인정보처리방침',
      type: 'item',
      url: '/policys',
      icon: icons.IconFileText,
      breadcrumbs: false
    },
    // {
    //   id: 'subscriptions',
    //   title: '무료 사용 현황',
    //   type: 'item',
    //   url: '/subscriptions',
    //   icon: icons.IconClipboardList,
    //   breadcrumbs: false
    // },
  ]
};

export default dashboard;
